import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import lodashCloneDeep from 'lodash/fp/cloneDeep';

import { RENTLINX_LISTING_LEAD_HIGHLIGHT_ARCHIVE_REASON_VALUES as highlightReasons } from 'common/rentlinxConstants';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';
import SrFlex from 'client/components/SrFlex';
import SrLeadOutcomesReasonItem from 'client/components/SrLeadOutcomes/SrLeadOutcomesReasonItem';

const SrLeadOutcomes = ({ archivedReasons }) => {
  const _getTotalArchivedLeads = () => {
    return (archivedReasons || []).reduce((acc, reason) => {
      return acc + (reason.count || 0);
    }, 0);
  };

  const _getCanReduceVacancy = () => {
    for (const archivedReason of archivedReasons || []) {
      if (highlightReasons.includes(archivedReason.name)) {
        return true;
      }
    }
    return false;
  };

  const _getSortedArchiveReasons = () => {
    const unsortedReasons = lodashCloneDeep(archivedReasons);
    return (unsortedReasons || []).sort((a, b) => b.count - a.count);
  };

  const _getArchivedReasonsComponents = () => {
    const sortedArchiveReasons = _getSortedArchiveReasons();
    return sortedArchiveReasons.map(({ name, label, count, details }) => (
      <SrLeadOutcomesReasonItem
        label={label}
        count={count}
        details={details}
        isHiglighted={highlightReasons.includes(name)}
      />
    ));
  };

  const totalArchivedLeads = _getTotalArchivedLeads();
  const archivedReasonsComponents = _getArchivedReasonsComponents();
  const canReduceVacancy = _getCanReduceVacancy();

  return (
    <SrCard>
      <SrFlexRow>
        <SrText font="greycliff" weight="800" fontSize="18px" lineHeight="24px">
          {totalArchivedLeads} Archived {pluralize('Lead', totalArchivedLeads)}
        </SrText>
      </SrFlexRow>
      {canReduceVacancy && (
        <SrFlexRow marginTop="5px">
          <SrText size="12" weight="500" color="orange300" lineHeight="18px">
            Sunroom highlights feedback in orange which you can act on to reduce vacancy.
          </SrText>
        </SrFlexRow>
      )}
      {totalArchivedLeads === 0 && (
        <SrFlexRow marginTop="8px">
          <SrText lineHeight="18px">
            You will see the specific reasons why leads who get archived are not interested in your
            listing.
          </SrText>
        </SrFlexRow>
      )}
      <SrFlex direction="col">{archivedReasonsComponents}</SrFlex>
    </SrCard>
  );
};

SrLeadOutcomes.propTypes = {
  archivedReasons: PropTypes.array.isRequired,
};

export default SrLeadOutcomes;
